import { render, staticRenderFns } from "./CreateKeeptalk.vue?vue&type=template&id=93672908&"
import script from "./CreateKeeptalk.vue?vue&type=script&lang=js&"
export * from "./CreateKeeptalk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports